import { render, staticRenderFns } from "./ChannelRegister.vue?vue&type=template&id=f4b8c6ac"
import script from "./ChannelRegister.vue?vue&type=script&lang=js"
export * from "./ChannelRegister.vue?vue&type=script&lang=js"
import style0 from "./ChannelRegister.vue?vue&type=style&index=0&id=f4b8c6ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports